import React, { useState, useEffect } from 'react';
import { Col, Row, PagingQuery } from 'tea-component';
import MediaNews from './MediaNews';
import NewGames from './NewGames';
import Activities from './Activities';
import { fetchCompaniesNewsActivityData } from '@/pages/intelligence/services/topcharts';
import { handleNewGamesData, handleActivities } from './utils';
import type { ICompaniesDetailsPageBaseProps } from '../types';
import { COMBINEID_REG } from '@intelligence/utils/constant';
// import Avatar from '@/pages/intelligence/assets/imgs/avatar.png';
// import AvatarTwo from '@/pages/intelligence/assets/imgs/avatar-two.png';
// import Avatarthere from '@/pages/intelligence/assets/imgs/avatar-there.png';

type INewsActivityProps = ICompaniesDetailsPageBaseProps;

const NewsActivity: React.FC<INewsActivityProps> = (props) => {
  const { companyId } = props;

  // 加载遮罩
  const [isLoading, setIsLoading] = useState(true);

  // 检索参数
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [total, setTotal] = useState(0);
  const [entityType, setEntityType] = useState('all');

  // 组件数据
  const [mediaData, setMediaData] = useState<any[]>([]);
  const [newGamesData, setNewGamesData] = useState<any[]>([]);
  const [highlightData, setHighlightData] = useState<any[]>([]);
  const [activitsData, setActivitsData] = useState<any[]>([]);

  // 获取页面信息
  const updatePageData = async (params: {
    companyId?: string;
    entityType?: string;
    pageIndex?: number;
    pageSize?: number;
  }) => {
    setIsLoading(true);
    const companyIdTmp = params?.companyId ?? companyId;
    const entityTypeTmp = params?.entityType ?? entityType;
    const pageIndexTmp = params?.pageIndex ?? pageIndex;
    const pageSizeTmp = params?.pageSize ?? pageSize;
    const result = await fetchCompaniesNewsActivityData({
      company_id: companyIdTmp,
      entity_type: entityTypeTmp === 'all' ? '' : entityTypeTmp?.toLowerCase(),
      page: pageIndexTmp,
      page_size: pageSizeTmp,
    });
    if (result.code === 0) {
      const resultData = result?.data;
      // @ts-ignore
      setTotal(resultData?.total_num ?? Number.NaN);
      // 数据分发组件
      setMediaData(resultData.media_news ?? []);
      setNewGamesData(handleNewGamesData(resultData?.game_list));
      setHighlightData(resultData.highlight_charts ?? []);
      setActivitsData(handleActivities(resultData.activities));
      // 清除遮罩
      setIsLoading(false);
    }
  };

  const handleEntityTypeChange = (payload: string) => {
    setEntityType(payload);
    updatePageData({ entityType: payload });
  };

  const handlePagingChange = (payload: PagingQuery) => {
    const pageIndexTmp = payload?.pageIndex ?? pageIndex;
    const pageSizeTmp = payload?.pageSize ?? pageSize;
    setPageIndex(pageIndexTmp);
    setPageSize(pageSizeTmp);
    updatePageData({
      pageIndex: pageIndexTmp,
      pageSize: pageSizeTmp,
    });
  };

  // 初始化掉接口
  useEffect(() => {
    if (!COMBINEID_REG.test(companyId)) return; // 添加ID校验规则
    updatePageData({ companyId });
  }, [companyId]);

  return (
    <Row>
      <Col span={16}>
        <MediaNews
          loading={isLoading}
          highlightData={highlightData}
          list={mediaData}
          total={total}
          pageIndex={pageIndex}
          pageSize={pageSize}
          onPagingChange={handlePagingChange}
          entityType={entityType}
          onEntityTypeChange={handleEntityTypeChange}
        />
      </Col>
      <Col span={8}>
        {isLoading ? null : (
          <NewGames
            loading={isLoading}
            companyId={companyId}
            entityType={entityType}
            data={newGamesData}
          />
        )}
        <Activities loading={isLoading} companyId={companyId} data={activitsData} />
      </Col>
    </Row>
  );
};

export default NewsActivity;
